import React from 'react';
import {Form,Radio, Select,Button,Spin} from 'antd';
import Ficon from 'components/Ficon';
import style from './index.less';
import FilterForm from 'components/FilterForm';
import BaseRangePicker from 'components/BaseRangePicker';
import BaseRangeMonthPicker from 'components/BaseRangeMonthPicker';
import BaseContent from 'components/BaseContent';
import Table from 'components/Table';
import {connect} from 'react-redux';
import {getConsumptionApp} from 'actions/consumption';
import {CreatChartOption} from 'utils/const';
import echarts from 'echarts';
import {getRealUrl} from 'utils/request';
const ButtonGroup = Button.Group;
const Option = Select.Option;
const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;


class KTPConsumption extends React.Component {
    state = {
        interval : 'day',
        selectAppKey:'no-limit',
        list:[],
        appList:[],
        showType:'table',
        canSearch:false,
        chartData:[],
        outUrl:'',
        data:{},
        loading:false
    }
    chartId = new Date().getTime()+this.MathRand();

    MathRand(){
        let Num = '';
        for(let i=0;i<6;i++)
        {
            Num+=Math.floor(Math.random()*10);
        }
        return Num;
    }
    componentDidMount(){
        //获取用户app列表
        getConsumptionApp().then(res=>{
            //自动搜索
            this.setState({appList:res,canSearch:true},()=>{
                this.table && this.table.resetChange();
            });

        });
        window.addEventListener('resize',()=>{
            if(this.myChart){
                const box = document.getElementById(this.chartId);
                if(box && box.clientHeight === 0){
                    return;
                }
                this.myChart.resize();
            }
        });
    }

    setChart(){
        let _data = this.state.chartData;
        if(!_data){
            _data = [];
        }
        const chartDom = document.getElementById(this.chartId);
        if(!chartDom){
            return;
        }
        this.myChart = echarts.init(chartDom);

        const {xdata,series} = this.props.chartSeries(_data);
        const option = CreatChartOption('',xdata,series);
        this.myChart.setOption(option,true);
    }

    onChange = (e)=>{
        this.setState({interval:e.target.value});
    }
    onAppChange = (value)=>{
        this.setState({selectAppKey:value});
    }
    onShowTypeChange = (e)=>{
        this.setState({showType:e.target.value});
        if(e.target.value === 'chart'){
            this.setState({loading:true});
            this.getData({page_size:0,page_id:1});
        }
    }

    onStart = (tableParams) => {
        tableParams = tableParams || {};
        const params = {};
        if(tableParams.order){
            params.order_by = tableParams.order;
        }
        if(typeof tableParams.asc !== 'undefined'){
            params.is_asc = tableParams.asc === 1;
        }
        // params.contract_type = [CONTRACT_TYPE.C.value];
        params.page_id = tableParams.current;;
        params.page_size = this.state.showType === 'table' ? tableParams.limit : 0;
        return this.getData(params);
    }

    getData(_params){
        if(!this.rangePicker){
            return;
        }

        const selectTime = this.rangePicker.getSelectTime();
        _params.start_ts = parseInt(selectTime[0].format('X'),10);
        _params.end_ts = parseInt(selectTime[1].format('X'),10);
        _params.account_id = this.props.account.account_id;
        _params.interval = this.state.interval;
        if(this.state.selectAppKey === 'no-limit'){
            _params.api_keys = this.state.appList.map(item=>{
                return item.api_key;
            });
        }else{
            _params.api_keys = [this.state.selectAppKey];
        }

        return this.props.getInfoPromise(_params).then(e => {
            this.setState({
                data:e.data,
                list: e.data.stats,
                total: e.data.total_count,
                outUrl:e.data.download_link,
                chartData:e.data.chart_data,
                loading:false,
            },()=>{
                if(this.state.showType !== 'table'){
                    this.setChart();
                }
            });
        }).catch(()=>{

        });
    }

    handleSubmit = (e) => {
        if(e){
            e.preventDefault();
        }
        this.filterParams = {};
        if(this.rangePicker){
            const selectTime = this.rangePicker.getSelectTime();
            this.filterParams = {
                ...this.filterParams,
                start_date:selectTime[0].format('YYYY-MM-DD'),
                end_date:selectTime[1].format('YYYY-MM-DD'),
            };
        }
        if(this.state.showType === 'table'){
            this.table && this.table.resetChange();
        }else{
            this.setState({loading:true});
            this.getData({page_size:0,page_id:1});
        }

    }

    onOutputClick = ()=>{
        window.open(getRealUrl(this.state.outUrl));
    }

    render() {
        let time = <BaseRangePicker ref={(ref)=>this.rangePicker=ref}/>;
        if(this.state.interval === 'month'){
            time = <BaseRangeMonthPicker ref={(ref)=>this.rangePicker=ref}/>;
        }
        let panel;
        if(this.state.showType === 'table'){
            panel = <Table
                sorter={{field: 'day', order: 'descend'}}
                dataSource={this.state.list}
                columns={this.props.columns}
                onSubmit={this.onStart}
                total={this.state.total}
                pageSize={this.props.pageSize || 10}
                ref={ref => this.table = ref}
            />;
        }else{
            panel = <div style={{height:'435px',borderTop:'1px #EEEEEE solid'}} id={this.chartId}></div>;
        }

        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <div style={{marginBottom:22,marginTop:20}}>
                        <FilterForm layout="inline" onSubmit={this.handleSubmit} disabledSubmit={!this.state.canSearch}>
                            <FormItem
                                label="App"
                            >
                                <Select
                                    disabled={this.state.apikeys === null}
                                    value={this.state.selectAppKey}
                                    style={{ width: 140 }}
                                    dropdownMatchSelectWidth={false}
                                    onChange={this.onAppChange}>
                                    <Option value='no-limit'>all</Option>
                                    {this.state.appList.map(item=>{
                                        return <Option value={item.api_key}>{item.name}</Option>;
                                    })}
                                </Select>
                            </FormItem>
                            <FormItem
                                label="Time range"
                            >
                                <RadioGroup onChange={this.onChange} defaultValue={this.state.interval}>
                                    <RadioButton value="day">Daily statistics</RadioButton>
                                    <RadioButton value="month">Monthly statistics</RadioButton>
                                </RadioGroup>
                                <span className={style.line}>&nbsp;</span>
                                {time}
                            </FormItem>

                        </FilterForm>
                    </div>
                    <BaseContent>
                        <div className={style.statistics}>
                            <h1>{this.props.title}</h1>
                            {this.props.subTitle(this.state.data)}
                            <div className={style.statisticsButton}>
                                <RadioGroup value={this.state.showType} onChange={this.onShowTypeChange}>
                                    <RadioButton className={style.sButtonItem} value="table"><Ficon type="list" />List</RadioButton>
                                    <RadioButton className={style.sButtonItem} value="chart"><Ficon type="chart" />Sparkline</RadioButton>
                                </RadioGroup>
                                <ButtonGroup style={{marginLeft:24}}>
                                    <Button type="primary" disabled={this.state.outUrl === ''} onClick={this.onOutputClick}>Output</Button>
                                </ButtonGroup>
                            </div>
                        </div>
                        {panel}
                    </BaseContent>
                </Spin>
            </div>
        );
    }

}


function select(state) {
    return {
        account: state.account.info
    };
}
export default connect(select)(KTPConsumption);



// WEBPACK FOOTER //
// ./src/components/BaseConsumption/index.js